module.exports = __webpack_public_path__ + "img/d-fbom.3be2d52b.gif";